import React from 'react'
import { Card, Spinner } from 'react-bootstrap'
import { Bar } from 'react-chartjs-2'
import { FaChartBar } from 'react-icons/fa'
import { SectionTitle, DetailCard, DetailHeader, ChartContainer } from '../styles'

interface DatasetAnalyticsPanelProps {
  loading: boolean
  chartData: {
    labels: string[]
    datasets: {
      label: string
      data: number[]
      backgroundColor: string
      borderColor: string
      borderWidth: number
    }[]
  }
  chartOptions: any
}

const DatasetAnalyticsPanel: React.FC<DatasetAnalyticsPanelProps> = ({
  loading,
  chartData,
  chartOptions,
}) => {
  return (
    <>
      <SectionTitle>
        <FaChartBar /> Dataset Analytics
      </SectionTitle>
      <DetailCard>
        <DetailHeader>
          <h3>Images & Annotations by Dataset</h3>
        </DetailHeader>
        <Card.Body style={{ height: '400px', padding: '1.5rem' }}>
          <ChartContainer>
            {loading ? (
              <div className="loading-overlay">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Bar
                data={chartData}
                options={{
                  ...chartOptions,
                  maintainAspectRatio: false,
                  responsive: true,
                }}
              />
            )}
          </ChartContainer>
        </Card.Body>
      </DetailCard>
    </>
  )
}

export default DatasetAnalyticsPanel
